import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList'
import CustomListContainer from '../Util/List/CustomList/CustomListContainer'

import '../home/Home.css';

const Entity = () => {

  const { friendly_url } = useParams();

  const [loading, setLoading] = useState(true)
  const [customPortal, setCustomPortal] = useState({})

  useEffect(() => {
    const loadData = async () => {
      let customData
      if (friendly_url) {
        customData = await Fetch.post(`${config.endpoints.backend}portal/getcustomizations`, { friendly_url, entity: true })
        if (customData != {}) {
          customData.logo = config.endpoints.backend + customData.logo
          customData.background_image = config.endpoints.backend + customData.background_image
          setCustomPortal(customData)
          setLoading(false)
        }
      }

    };

    loadData();
  }, [])

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getallprojects'
  }

  const list = {
    labelTitle: 'Projetos da Entidade',
    icon: 'fa-building',
    viewActionColumn: false,
    filter: {
      friendly_url
    },
    columns: [
      {
        name: 'project_name',
        label: 'Projeto'
      },
      {
        name: 'description',
        label: 'Descrição'
      }
    ],
    columnsButtons: [
      {
        buttons: [
          {
            width: '15%',
            label: 'Link para o Projeto',
            // icon: 'fas fa-users',
            onClick: item => {
              window.location = `../${item.project_url}/home`
            }
          }
        ]
      }
    ]
  };

  return (
    !loading && (
      <>
        <div className="portal-home-container">
          <header className="portal-navbar">
            <div className="portal-logo">
              <img style={{ width: '200px' }} src={customPortal.logo} alt="uploaded" />
            </div>
            <div className="portal-title-subtitle">
              <h1 style={{ color: customPortal.primary_color }}>
                <b>Plataforma de Transparência</b>
              </h1>
              <h2 style={{ color: customPortal.secondary_color }}>
                {customPortal.entity_name}
              </h2>
            </div>
          </header>
          <section
            className="portal-content"
            style={{
              paddingTop: '0',
              textAlign: 'left',
            }}>

            <CustomListContainer
              canAdd={false}
              labelTitle={list.labelTitle}
              icon={list.icon}
              primary_color={customPortal.primary_color}
              content={<CustomList list={{ ...list, ...paths }} />}
            />
          </section>
        </div>
      </>
    )
  );
};

export default Entity;
